import React from 'react';
import {useDraggable} from '@dnd-kit/core';
import { useSelector } from 'react-redux';

export const Draggable = (props) => {
    const { id, styles={}, onClick = ()=>{}, origin, isDragging } = props;
    const { attributes, listeners, setNodeRef, transform } = useDraggable({
        id: id,
    });

    const isAnimating = useSelector(state => state.game.isAnimating);

    const style = transform ? {
        ...styles,
        transform: `translate(${transform.x}px, ${transform.y}px)`,
    } : styles;

    const handleClick = () => {
        if (isDragging) return;
        onClick(id);
    }

    return (
        <button
            data-origin={origin}
            ref={setNodeRef}
            style={{...style, userSelect: 'none'}}
            {...listeners}
            onPointerUp={handleClick}
            {...attributes}
            disabled={isAnimating}
        >
            {props.children}
        </button>
    );
}